/**
 * Returns a non-versioned id from a versioned uuid
 * @param {String} uuid Versioned UUID string
 */
export default function stripVersion(uuid: string) {
  const id = uuid.split("-");
  id.pop();
  return id.join("-");
}
